import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
    selector: '[checkoutKonami]',
    standalone: true,
})
export class KonamiDirective {
    @Input() public konamiCode: string[] = [
        'ArrowUp',
        'ArrowUp',
        'ArrowDown',
        'ArrowDown',
        'ArrowLeft',
        'ArrowRight',
        'ArrowLeft',
        'ArrowRight',
        'KeyB',
        'KeyQ',
    ];

    @Output() private checkoutKonami: EventEmitter<boolean>;

    private konamiCodeTest: string[];

    constructor() {
        this.checkoutKonami = new EventEmitter<boolean>();
        this._reinitKonamiCode();
    }

    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent): void {
        if (event.code) {
            // Ilyas style
            if (event.code.toString() === this.konamiCodeTest[0]) {
                this.konamiCodeTest.shift();

                if (this.konamiCodeTest.length === 0) {
                    this.checkoutKonami.emit(true);
                    this._reinitKonamiCode();
                }
            } else {
                this._reinitKonamiCode();
            }
        }
    }

    private _reinitKonamiCode(): void {
        this.konamiCodeTest = [...this.konamiCode];
    }
}
